import { checkPayment, getPaymentState } from '@/store/slices/stagesSlice/stagesSlice'
import { CreatePaymentStatus } from '@/store/slices/stagesSlice/interfaces'
import PaymentPendingPage from './PaymentPending'
import PaymentSuccessPage from './PaymentSuccess'
import PaymentErrorPage from './PaymentError'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { useDispatch, useSelector } from 'react-redux'
import { useState, useCallback } from 'react'
import { RootState } from '@/store'
import PaymentSubscriptionSuccessByAppPage from '@/components/pages/PaymentPage/PaymentSubscriptionSuccessByApp'
import PaymentEventSuccessPage from './PaymentEventSuccessPage'
import { useFetchPaymentStatus } from '@/helpers/hooks/useFetchPaymentStatus'
import PaymentFinesSuccessPage from '@/components/pages/PaymentPage/PaymentFinesSuccessPage'
import { DELAY_PAYMENT_RESULT, COUNT_REQUEST_PAYMENT_RESULT } from '@/constants'

export default function PaymentResult({ token }: { token: string }) {
  const [status, setStatus] = useState<CreatePaymentStatus | 'exhausted'>('pending')
  const dispatch = useDispatch()
  const reduxState = useSelector<RootState, RootState>(state => state)

  const { data } = getPaymentState(reduxState)
  const { paidUntil, area, type, paidUntilEvent } = data

  const fetchData = useCallback(async () => {
    await dispatch(
      checkPayment({
        token,
        onSuccess: ({ status }) => {
          setStatus(status)
        },
        onError: status => {
          setStatus(status)
        },
      }),
    )
  }, [])

  useFetchPaymentStatus({ fetchData, status, setStatus, delay: DELAY_PAYMENT_RESULT, maxCountRequest: COUNT_REQUEST_PAYMENT_RESULT })

  const renderPaymentResultPage = () => {
    switch (true) {
      case status === 'pending':
        return <PaymentPendingPage />
      case status === 'success' && type === 'Stage':
        return <PaymentSuccessPage paidUntil={paidUntil} area={area} />
      case status === 'success' && type === 'ClientSubscription':
        return <PaymentSubscriptionSuccessByAppPage paidUntil={paidUntil} area={area} />
      case status === 'success' && type === 'ClientEvent':
        return <PaymentEventSuccessPage area={area} paidUntilEvent={paidUntilEvent} />
      case status === 'success' && type === 'Fine':
        return <PaymentFinesSuccessPage area={area} />
      default:
        return <PaymentErrorPage area={area} status={status} type={type} />
    }
  }

  return (
    <SwitchTransition>
      <CSSTransition key={status} timeout={{ appear: 0, enter: 0, exit: 600 }} classNames="on">
        {renderPaymentResultPage()}
      </CSSTransition>
    </SwitchTransition>
  )
}
